export default __webpack_public_path__ + "static/media/affinityDiagramApp.5eeab56a.jpg";